import { decodeToken } from "@nju/data-access-portal-wwt";
import { ACCESS_TOKEN_SALES_KEY_NAME } from "@nju/scope";

export function getUserName(): string | undefined {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_SALES_KEY_NAME);

  const decodedToken = decodeToken(accessToken);

  return decodedToken?.name;
}
